// extracted by mini-css-extract-plugin
export default {"title":"s_title__JBHFe","img-wrapper":"s_img-wrapper__5i1rf","img":"s_img__NJsf7"};